import type { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import axios, { AxiosRequestTransformer } from "axios";
import { getAccessTokenForService } from "@/Services/Auth0/auth0-plugin";
import { AxiosKey } from '@/Services/HttpClient/symbols'
import apiClient, { isAxiosError } from '@/Services/HttpClient/axios-plugin'
//import { AppConfig } from '../../public/static/appConfig'

export abstract class BaseApiService {
    protected readonly httpClient: AxiosInstance;

    protected constructor(protected readonly path?: string, protected readonly baseURL: string = '/api/') {
        const dateTransformer = (value: any): any => {
            if (value instanceof Date) {
                return value.toISOString();
            }
            if (Array.isArray(value)) {
                return value.map(dateTransformer);
            }
            if (typeof value === 'object' && value !== null) {
                return Object.fromEntries(Object.entries(value).map(([key, value]) => [key, dateTransformer(value)]));
            }
            return value;
        }

        baseURL = process.env.VUE_APP_PORTAL_API + baseURL

        if (path) {
             baseURL += path;
        }
        this.httpClient = axios.create({
            baseURL,
            headers: {
                'Content-type': 'application/json',
            },
            transformRequest: [dateTransformer, ...(axios.defaults.transformRequest as AxiosRequestTransformer[])],
        });
        //from plugin
        //this.httpClient = apiClient;

        this.httpClient.interceptors.request.use(async (config) => {
            if (config.headers['AuthorizationNeeded']) {
                const token = await getAccessTokenForService();
                //console.log('interceptor accessToken set: ' + token);
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        });
        
    }

    protected handleResponse<T>(response: AxiosResponse<T>): T {
        return response.data;
    }

    protected handleError(error: unknown): never {
        if (error instanceof Error) {
            if (isAxiosError(error)) {
                if (error.response) {
                    //Uncomment any or all below for better debugging
                    //console.error(error.response.data);
                    //console.error(error.response.status);
                    //console.error(error.response.headers);
                    throw error;
                }
                else if (error.request) {
                    //console.error(error.request);
                    throw new Error(error as any);
                }
            }
            else {
                //console.error(error.message);
                throw new Error(error as any);
                throw new Error(error as any);
            }
        }
        throw new Error(error as any);
    }
}